export default "__VITE_ASSET__10948e79__"